import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

import { ROUTES } from '../constants/app.constants';
import { AuthService, isAdmin } from '../services/auth.service';

/**
 * Protege rutas privadas: redirige a login si no hay sesión.
 * Conserva la URL solicitada en `returnUrl` para volver tras autenticarse.
 */
export const authGuard: CanActivateFn = (_route, state) => {
  const auth = inject(AuthService);
  const router = inject(Router);

  // Sesion Y rol. Solo con `isAuthenticated()` una cuenta que no sea ADMIN
  // entraba a la interfaz y se topaba con un 403 en cada peticion: el backend
  // aguantaba, pero el panel se veia roto en vez de rechazar el acceso.
  if (auth.isAuthenticated()) {
    if (isAdmin(auth.user())) {
      return true;
    }
    auth.logout();
    return router.createUrlTree([ROUTES.login], {
      queryParams: { error: 'not-admin' },
    });
  }

  return router.createUrlTree([ROUTES.login], {
    queryParams: { returnUrl: state.url },
  });
};

/**
 * Evita que un usuario ya autenticado acceda a páginas públicas (p. ej. login).
 */
export const guestGuard: CanActivateFn = () => {
  const auth = inject(AuthService);
  const router = inject(Router);

  return auth.isAuthenticated() ? router.createUrlTree([ROUTES.dashboard]) : true;
};
